export default "<ion-app>\n  <ion-split-pane>\n    <ion-router-outlet main></ion-router-outlet>\n  </ion-split-pane>\n</ion-app>\n"